import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import UnitTabHeader from './unit/unitTabHeader';
import CoachCourse from '../coachCourse/coachCourse.container';
import IWantToFilter from './iWantToFilter/iWantToFilter.container';
import Card from 'react-bootstrap/Card';

const Detail = ({ isCoachCourse, courseType }) => {
	const [elementFilter, setElementFilter] = useState('any');

	return (
		<Card>
			<Card.Body className="unitsContainer">
				{isCoachCourse ? (
					<CoachCourse />
				) : (
					<Card className="border-0 ">
						<Card.Header className="unitsHeader">
							<h4>Table of Content</h4>
							{/* {courseType !== 'live' && (
								<IWantToFilter
									setElementFilter={setElementFilter}
									elementFilter={elementFilter}
								/>
							)} */}
						</Card.Header>
						<Card.Body>
							<UnitTabHeader elementFilter={elementFilter} />
						</Card.Body>
					</Card>
				)}
			</Card.Body>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const { isCoachCourse, courseType } = state.rootReducer.myCourse;
	return {
		isCoachCourse,
		courseType,
	};
};

export default compose(connect(mapStateToProps))(Detail);
